/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useState, useRef, useEffect } from 'react';
import { toast } from 'react-toastify';
import { FormGroup } from '../../common';
import { Button, Heading, Text } from '../../styledComponents';
import styles from './EditDiscountCodeModal.module.css';
import { updateDiscountCode } from '../../../services/dashboard.service';

type EditDiscountModalProps = {
  setShowEditDiscountCodeModal: React.Dispatch<React.SetStateAction<boolean>>;
  fetchHomePageData: () => void;
  profileId: string;
  selectedDiscountCode: {
    code: string;
    type: string;
    discount_value: number;
    discount_type: string;
    can_change: boolean;
  } | null;
  affiliateId: number;
};

export default function EditDiscountCodeModal({
  profileId,
  fetchHomePageData,
  setShowEditDiscountCodeModal,
  selectedDiscountCode,
  affiliateId,
}: EditDiscountModalProps) {
  const [discountCodeName, setDiscountCodeName] = useState<string>('');
  const [disableButton, setDisableButton] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const modalRef = useRef<null | HTMLDivElement>(null);

  const handleOutsideClick = (e: any) => {
    if (!modalRef.current?.contains(e.target)) {
      setShowEditDiscountCodeModal(false);
    }
  };

  const handleUpdateDiscountCode = async () => {
    if (discountCodeName.trim() === selectedDiscountCode?.code?.trim()) {
      toast.success('Discount coode updated successfully');
      setShowEditDiscountCodeModal(false);
      return;
    }

    setDisableButton(true);
    const body = {
      profileId,
      affiliateId,
      oldDiscountCode: selectedDiscountCode,
      newDiscountCodeName: discountCodeName,
    };
    // api call here
    const response: any = await updateDiscountCode(body);

    if (response?.status) {
      toast.success(response.message);
      setShowEditDiscountCodeModal(false);
      fetchHomePageData();
      setDisableButton(false);
    } else {
      toast.error(response.message);
      setErrorMessage(response.message);
      setDisableButton(false);
    }
  };

  useEffect(() => {
    setDiscountCodeName(selectedDiscountCode?.code || '');
  }, [selectedDiscountCode]);

  return (
    <div className={styles.modalWrapper} onClick={handleOutsideClick}>
      <div className={styles.modal} ref={modalRef}>
        <div className={styles.formSection}>
          <Heading as="h3" fontWeight="500" fontSize="16px" color="#353535" textTransform="uppercase">
            Edit Your Code
          </Heading>
          <FormGroup
            name="discountCodeName"
            label="Discount Code"
            type="text"
            placeholder=""
            value={discountCodeName}
            onChange={(e) => setDiscountCodeName(e.target.value)}
            errorText=""
            required
            autoFocus
          />

          {/* error message here */}
          {errorMessage && <Text color="var(--red)">{errorMessage}</Text>}

          <div className={styles.group}>
            <Button
              bgColor="transparent"
              color="var(--dark-grey)"
              style={{ border: '1px solid var(--light-grey)' }}
              type="button"
              onClick={() => setShowEditDiscountCodeModal(false)}
            >
              Cancel
            </Button>
            <Button
              bgColor="var(--saral-purple)"
              type="button"
              onClick={handleUpdateDiscountCode}
              disabled={!discountCodeName || disableButton}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
